import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const HamburgerMenu2Icon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.92334 8.82141C3.92334 8.26913 4.37106 7.82141 4.92334 7.82141H20.9233C21.4756 7.82141 21.9233 8.26913 21.9233 8.82141C21.9233 9.3737 21.4756 9.82141 20.9233 9.82141H4.92334C4.37106 9.82141 3.92334 9.3737 3.92334 8.82141ZM3.92334 16.8214C3.92334 16.2691 4.37106 15.8214 4.92334 15.8214H20.9233C21.4756 15.8214 21.9233 16.2691 21.9233 16.8214C21.9233 17.3737 21.4756 17.8214 20.9233 17.8214H4.92334C4.37106 17.8214 3.92334 17.3737 3.92334 16.8214Z"
            />
        </SvgIcon>
    );
};

export default HamburgerMenu2Icon;
